/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2022, Zumper
 * @description ZoomControl Component
 */

import { NavigationControl, type NavigationControlProps } from '@vis.gl/react-mapbox'
import React from 'react'
import * as styles from './style'

export const ZoomControl = ({
  position = 'bottom-right',
  showCompass = false,
  showZoom = true,
  visualizePitch,
  style,
}: NavigationControlProps) => (
  <div
    className="relative [&_.mapboxgl-ctrl-group]:bg-backgroundLight [&_.mapboxgl-ctrl-group]:shadow-md [&_.mapboxgl-ctrl-group]:rounded-md [&_.mapboxgl-ctrl-group:not(:empty)]:shadow-md [&_.mapboxgl-ctrl-group>button]:w-8 [&_.mapboxgl-ctrl-group>button]:h-8"
    css={styles.navigationControl}
  >
    <NavigationControl
      position={position}
      showCompass={showCompass}
      showZoom={showZoom}
      style={style}
      visualizePitch={visualizePitch}
    />
  </div>
)
